import { LOCAL_STORAGE_TYPES } from '@/constants/localStorageTypes'
import { AGENTS } from '@/constants/aiAgents'

function getBarsPositions() {
    const positions = JSON.parse(localStorage.getItem('bars'))

    if (!positions) {
        return { miniMain: true, mini: false }
    }
    const { miniMain = true, mini = false } = positions

    return { miniMain, mini }
}

function setBarsPositions({ miniMain, mini }) {
    localStorage.setItem('bars', JSON.stringify({ miniMain, mini }))
}

function _getRestartLocalStorage() {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_TYPES.restart))
}

function setRestartLocalStorage() {
    const restart = _getRestartLocalStorage()
    localStorage.setItem(LOCAL_STORAGE_TYPES.restart, JSON.stringify(!restart))
}

function addEventListenerStorage() {
    window.addEventListener('storage', ({ key, storageArea }) => {
        if (storageArea !== localStorage) return

        if (key === LOCAL_STORAGE_TYPES.restart) {
            location.reload()
        }
    })
}

function getGettingStartPageLocalStorage() {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_TYPES.isGettingStart))
}

function setGettingStartPageLocalStorage() {
    const isGettingStart = getGettingStartPageLocalStorage()
    localStorage.setItem(LOCAL_STORAGE_TYPES.isGettingStart, JSON.stringify(!isGettingStart))
}

function getConfirmTranscriptionLocalStorage() {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_TYPES.dontShowConfirmForTranscription))
}

function setConfirmTranscriptionLocalStorage(value) {
    localStorage.setItem(LOCAL_STORAGE_TYPES.dontShowConfirmForTranscription, value)
}

function getCurrentAiAgent() {
    try {
        const currentAgent = localStorage.getItem(LOCAL_STORAGE_TYPES.currentAiAgent)

        return currentAgent ? JSON.parse(currentAgent) : AGENTS.diagnostic
    } catch {
        return AGENTS.diagnostic
    }
}

function saveCurrentAiAgent(agent) {
    localStorage.setItem(LOCAL_STORAGE_TYPES.currentAiAgent, JSON.stringify(agent))
}

function loadAiConversationFromStorage(type) {
    try {
        const conversationId = localStorage.getItem(type === AGENTS.diagnostic.type
            ? LOCAL_STORAGE_TYPES.diagnosticAiConversationId
            : LOCAL_STORAGE_TYPES.builderAiConversationId)

        const messages = localStorage.getItem(type === AGENTS.diagnostic.type
            ? LOCAL_STORAGE_TYPES.diagnosticAiMessages
            : LOCAL_STORAGE_TYPES.builderAiMessages)

        return {
            conversationId: conversationId ? JSON.parse(conversationId) : null,
            messages: messages ? JSON.parse(messages) : [],
        }
    } catch {
        return {
            conversationId: null,
            messages: [],
        }
    }
}

function saveAiConversationToStorage(messages, conversationId, type) {
    try {
        localStorage.setItem(
            type === AGENTS.diagnostic.type
                ? LOCAL_STORAGE_TYPES.diagnosticAiMessages
                : LOCAL_STORAGE_TYPES.builderAiMessages,
            JSON.stringify(messages),
        )

        if (conversationId.value) {
            localStorage.setItem(
                type === AGENTS.diagnostic.type
                    ? LOCAL_STORAGE_TYPES.diagnosticAiConversationId
                    : LOCAL_STORAGE_TYPES.builderAiConversationId,
                conversationId,
            )
        }
    } catch { /* ignore */ }
}

function clearAiConversationStorage(type) {
    try {
        localStorage.removeItem(type === AGENTS.diagnostic.type
            ? LOCAL_STORAGE_TYPES.diagnosticAiMessages
            : LOCAL_STORAGE_TYPES.builderAiMessages)

        localStorage.removeItem(type === AGENTS.diagnostic.type
            ? LOCAL_STORAGE_TYPES.diagnosticAiConversationId
            : LOCAL_STORAGE_TYPES.builderAiConversationId)
    } catch { /* ignore */ }
}

export {
    getBarsPositions,
    setBarsPositions,
    addEventListenerStorage,
    setRestartLocalStorage,
    getGettingStartPageLocalStorage,
    setGettingStartPageLocalStorage,
    getConfirmTranscriptionLocalStorage,
    setConfirmTranscriptionLocalStorage,
    getCurrentAiAgent,
    saveCurrentAiAgent,
    loadAiConversationFromStorage,
    saveAiConversationToStorage,
    clearAiConversationStorage,
}
